// shape divider
function updateShapeDividerPosition() {
  const shapeMiddle = document.querySelectorAll(".shopify-section.shape-divider-middle");

  shapeMiddle.forEach((section) => {
    const svg = section.querySelector(".shape-divider svg");

    if (svg) {
      const svgHeight = Math.floor(svg.getBoundingClientRect().height);

      let styleTag = document.querySelector(`#style-${section.id}`);
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = `style-${section.id}`;
        document.head.appendChild(styleTag);
      }

      styleTag.textContent = `
        #${section.id}::after {
          top: calc(50% + ${svgHeight}px);
          height: calc(50% - ${svgHeight}px);
        }
      `;
    }
  });
}



// 장바구니 버튼 위치 잡기
function getPureContentHeight(element) {
  const style = window.getComputedStyle(element);
  const paddingTop = parseFloat(style.paddingTop) || 0;
  const paddingBottom = parseFloat(style.paddingBottom) || 0;
  const totalHeight = element.getBoundingClientRect().height;

  return totalHeight - paddingTop - paddingBottom;
}

function positionTElement() {
  const productObs = document.querySelectorAll(`div[id*="featured_product_variants"] .product-media-object, div[id*="product-grid"] .product-media-object, div[id*="featured_collection"] .product-media-object, div[id*="mixed_shape_product_grid"] .product-media-object`);
  const quickBuys = document.querySelectorAll(`div[id*="featured_product_variants"] .product-quick-buy__container, div[id*="product-grid"] .product-quick-buy__container, div[id*="featured_collection"] .product-quick-buy__container, div[id*="mixed_shape_product_grid"] .product-quick-buy__container`);

  if (!productObs.length || !quickBuys.length) return;

  productObs.forEach((productOb, i) => {
    const quickBuy = quickBuys[i];
    if (!quickBuy) return;

    const productObH = getPureContentHeight(productOb);
    const quickBuyH = quickBuy.offsetHeight;
    const offset = 10;

    const quickBuyTop = productOb.offsetTop + productObH - offset - quickBuyH;
    quickBuy.style.top = `${quickBuyTop}px`;
  });
}



// ResizeObserver로 productObs의 높이 변화 감지
const productObs = document.querySelectorAll(`div[id*="featured_product_variants"] .product-media-object, div[id*="product-grid"] .product-media-object, div[id*="featured_collection"] .product-media-object, div[id*="mixed_shape_product_grid"] .product-media-object`);
const observer = new ResizeObserver(() => {
  positionTElement();
});

productObs.forEach((el) => {
  observer.observe(el);
});





// 디바운스 함수
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const debouncedUpdate = debounce(updateShapeDividerPosition, 100);
const handlePosition = debounce(positionTElement, 100);
const debouncedResizeAccordionHeight = debounce(resizeAccordionHeight, 100);


// 초기 실행
window.addEventListener("load", updateShapeDividerPosition);
window.addEventListener('load', handlePosition);
// 리사이즈 시 디바운스로 최적화
window.addEventListener("resize", debouncedUpdate);
window.addEventListener('resize', handlePosition);
// group PDP 아코디언
window.addEventListener('resize', debouncedResizeAccordionHeight);
window.addEventListener('load', resizeAccordionHeight);




document.addEventListener("DOMContentLoaded", () => {
  const roots = document.querySelectorAll('div[id*=b7_custom_made]');

  roots.forEach(root => {
    const moreLinks = root.querySelectorAll('.more-link');
    const textItems = root.querySelectorAll('.text-item');
    const descWrappers = root.querySelectorAll('.desc-wrapper');
    const blockImages = root.querySelectorAll('.block-image');

    moreLinks.forEach((link, idx) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const currentItem = textItems[idx];
        const currentDesc = descWrappers[idx];
        const currentImg = blockImages[idx];

        const isAlreadyActive = currentItem.classList.contains('active');

        // 열려 있는 항목은 다시 눌러도 아무 변화 없음 (닫히지 않음)
        if (isAlreadyActive) return;

        // 다른 애들 초기화
        textItems.forEach((item, i) => {
          if (i !== idx) {
            item.classList.remove('active');
            descWrappers[i].classList.remove('active');
            descWrappers[i].style.height = '';
            blockImages[i].classList.remove('active');
            moreLinks[i].classList.remove('active');
          }
        });

        // 현재 항목 활성화
        link.classList.add('active');
        currentItem.classList.add('active');
        currentDesc.classList.add('active');
        currentImg.classList.add('active');

        requestAnimationFrame(() => {
          currentDesc.style.height = currentDesc.scrollHeight + 'px';
        });
      });
    });

    // 페이지 로드 시 첫 항목 열기
    const firstActive = root.querySelector('.text-item.active');
    if (firstActive) {
      const firstIdx = Array.from(textItems).indexOf(firstActive);
      const firstDesc = descWrappers[firstIdx];
      const firstImg = blockImages[firstIdx];

      firstDesc.classList.add('active');
      firstDesc.style.height = firstDesc.scrollHeight + 'px';
      blockImages.forEach(img => img.classList.remove('active'));
      firstImg.classList.add('active');
    }
  });
});

function resizeAccordionHeight() {
  document.querySelectorAll('div[id*=b7_custom_made]').forEach(root => {
    const textItems = root.querySelectorAll('.text-item');
    const descWrappers = root.querySelectorAll('.desc-wrapper');

    textItems.forEach((item, i) => {
      if (item.classList.contains('active')) {
        const desc = descWrappers[i];
        
        // 초기화 → 강제로 높이 재계산 유도
        desc.style.height = 'auto'; // 또는 ''로 리셋
        const newHeight = desc.scrollHeight;
        desc.style.height = newHeight + 'px';
      }
    });
  });
}




document.querySelectorAll('#headerContainer nav .no-js-focus-wrapper').forEach(li => {
  const megamenu = li.querySelector('#headerContainer nav .no-js-focus-container');
  if (megamenu) {
    li.classList.add('have-megamenu');
  } else {
    li.classList.remove('have-megamenu'); // 혹시 동적으로 바뀔 경우를 대비
  }
});








